import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: 'AIzaSyDTWKUGB8YIB0ilE2MHctKvjv88xJ6TEEI',
  // On mykart.pl sign in through the app's own /__/auth handler: iOS keeps a
  // subdomain's storage apart, so a Google redirect via auth.mykart.pl comes
  // back without its result (standalone PWAs can only sign in by redirect).
  authDomain: typeof window !== 'undefined' && window.location.hostname === 'mykart.pl' ? 'mykart.pl' : 'auth.mykart.pl',
  projectId: 'mykart-f72ef',
  storageBucket: 'mykart-f72ef.firebasestorage.app',
  messagingSenderId: '824626813942',
  appId: '1:824626813942:web:b08386dde6838ae22b45d7',
  databaseURL: 'https://mykart-f72ef-default-rtdb.europe-west1.firebasedatabase.app'
};

const emulator = process.env.REACT_APP_USE_EMULATORS === 'true';
const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const configured = emulator ? {
  apiKey: 'demo-key', projectId: 'demo-mykart-trusted', authDomain: 'localhost',
  storageBucket: 'demo-mykart-trusted.appspot.com', databaseURL: 'https://demo-mykart-trusted.firebaseio.com',
} : projectId ? {
  ...firebaseConfig,
  projectId,
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // A preview channel serves its own /__/auth handler. Signing in through it keeps
  // Google login same-site, which iOS needs: with firebaseapp.com its partitioned
  // storage loses the login state ("missing initial state").
  authDomain: process.env.REACT_APP_GAMES_STAGING === 'true' && window.location.hostname.endsWith('.web.app')
    ? window.location.host
    // Production keeps auth.mykart.pl: .env's firebaseapp.com would show in the Google popup.
    : projectId === firebaseConfig.projectId ? firebaseConfig.authDomain : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || firebaseConfig.storageBucket,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || firebaseConfig.databaseURL,
} : firebaseConfig;

const app = initializeApp(configured);

export default app;
